import React, {useState, useEffect, useRef} from "react";
import {DEFAULT_BLUE} from "../../../constants/general-constants";
import {functions} from "../../../constants/common-functions";
import {STRINGIFY} from "../../../constants/general-constants";
import {INPUT_TYPE_TEXT} from "../../../constants/input-types";
import {INPUT_TYPE_TEXTAREA} from "../../../constants/input-types";
import {INPUT_TYPE_SELECT} from "../../../constants/input-types";
import EditChildPanel from '../components/EditChildPanel';
import UserFacilityMatrixRow from '../components/UserFacilityMatrixRow';
import {YES_NO_OPTIONS} from "../../../constants/general-constants";

export default function AdminListPanelUserFacilityMatrix({userId, setFunction, currentUserFacilityMatricies}){
	
	const [facilities, setFacilities] = useState([]);
	const [userFacilityMatricies, setUserFacilityMatricies] = useState([]);

	
	useEffect(() => {
		loadFacilities();
	}, [userId]);
	
	const loadFacilities = () => {
		functions.getArrayFromAjax("/resolution/facilities",  setFacilities, loadFacilityMatricies);
	};
	
	
	const loadFacilityMatricies = (thisFacilities) => {
		functions.getArrayFromAjax("/resolution/userfacilitymatricies?userId=" + userId,  setUserFacilityMatricies, resetParent);
	};
	
	const resetParent = (matricies) => {
		setFunction(matricies);
	};
	
	const thisContainer = {
		display:"flex",
		width:"calc(50% - 40px)",
		backgroundColor:"#eee",
		borderRadius:"4px",
		minHeight:"200px",
		marginLeft:"30px",
		flexDirection:"column",
		paddingBottom:"30px"
	};
	
	const titlePanel = {
		display:'flex',
		width:"calc(100% - 20px)",
		alignItems:"center",
		justifyContent:"space-between",
		color:"black",
		height:"40px",
		fontSize:"14px",
		marginLeft:"10px"
	};
	
	const blueButton = {
		display:"flex",
		width:"100px",
		height:"20px",
		backgroundColor:DEFAULT_BLUE,
		borderRadius:"15px",
		color:"white",
		fontSize:"12px",
		cursor:"pointer",
		marginRight:"10px",
		marginTop:"0px",
		alignItems:"center",
		justifyContent:"space-around",
		boxShadow:'0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.13)',
	};
	
	const rowContainer = {
		display:"flex",
		width:"calc(100% - 10px)",
		marginLeft:"5px",
		flexDirection:"column",
		marginTop:"10px"
	};
	
	const getValidUserFacilityMatricies = () => {
		
	};
	
	const checkFunction = (isChecked, facilityId, dateFrom, dateTo) => {
		let tempUserFacilityMatricies = [];
		for(let i=0; i<userFacilityMatricies.length; i++){
			if(userFacilityMatricies[i].facilityId != facilityId){
				tempUserFacilityMatricies.push({
				id:"-100",
				userId:userId,
				facilityId:userFacilityMatricies[i].facilityId,
				dateFrom:userFacilityMatricies[i].dateFrom,
				dateTo:userFacilityMatricies[i].dateTo
			});
			}
		}
		if(isChecked === true){
			tempUserFacilityMatricies.push({
				id:"-100",
				userId:userId,
				facilityId:facilityId,
				dateFrom:dateFrom,
				dateTo:dateTo
			});
		}
		setUserFacilityMatricies(tempUserFacilityMatricies);
		setFunction(tempUserFacilityMatricies);
	};
	
	const setAll = (inputFacilityId, inputDateFrom, inputDateTo) => {
		let tempUserFacilityMatricies = [];
		let found = false;
		for(let i=0; i<userFacilityMatricies.length; i++){
			if(userFacilityMatricies[i].facilityId === inputFacilityId){
				found = true;
			}
			tempUserFacilityMatricies.push({
				id:"-100",
				userId:userId,
				facilityId:userFacilityMatricies[i].facilityId,
				dateFrom:inputDateFrom,
				dateTo:inputDateTo
			});
		}
		
		if(found === false){
			tempUserFacilityMatricies.push({
				id:"-100",
				userId:userId,
				facilityId:inputFacilityId,
				dateFrom:inputDateFrom,
				dateTo:inputDateTo
			});
		}
		
		setFunction(tempUserFacilityMatricies);
		setUserFacilityMatricies(tempUserFacilityMatricies);
	};
	
	const rowDisplay = facilities.map((item, index) => 
			<UserFacilityMatrixRow
				userId={userId}
				facilityId={item.id}
				facilityName={item.name}
				userFacilityMatricies={userFacilityMatricies}
				checkFunction={checkFunction}
				setAll = {setAll}
			/>
	);
	
	const getSubmitObject = () => {
		
		let submitObject = {
			userId:userId,
			entities:getValidUserFacilityMatricies()
		};
		return submitObject;
	}
	
	const goSubmit = () => {
		
		functions.submitAjax("/resolution/userfacilitymatriciesbulksave", 
				getSubmitObject(), saveEnd,  STRINGIFY, handleSubmitError);
		
	};
	
	const handleSubmitError = (e) => {
		console.log(e);
	};
	
	const saveEnd = () => {
		
	};
	
	
	return (
		<div style={thisContainer}>
			<div style={titlePanel}>
				Allocate Facilities/Properties
			</div>
			<div style={rowContainer}>
				{rowDisplay}
			</div>		
		</div>
		
	);
}